// Copyright 2025, University of Maryland, All Rights Reserved
import { useQuery } from '@tanstack/react-query'
import { AxiosInstance } from 'axios'
import { createMetricsApi, MetricLevel } from '../services/metrics-api'
import type { MonthlyMetricsResponse } from '../types'

const getCurrentYear = () => new Date().getFullYear()

export const useMonthlyMetrics = (
  api_instance: AxiosInstance,
  organization_id: string,
  workspace_id: string,
  level: MetricLevel = 'workspace',
  year: number = getCurrentYear()
) => {
  const metricsApi = createMetricsApi(api_instance)

  const { data, isPending, isError } = useQuery({
    queryKey: ['metrics', 'monthly', year, organization_id, workspace_id, level],
    queryFn: async () => {
      return await metricsApi.getMonthlyMetrics(year, organization_id, workspace_id, level)
    },
    staleTime: 300000,
    gcTime: 3600000,
    enabled: !!organization_id && (level === 'org' || level === 'app' || !!workspace_id),
  })

  return {
    metrics: data || ({} as MonthlyMetricsResponse),
    isLoading: isPending,
    error: isError ? 'Failed to load metrics' : null,
  }
}
